import { makeStyles } from "@material-ui/core/styles";

const myStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1,
    fontFamily: "cursive"
  },

  button: {
    marginRight: theme.spacing(2)
  },

  welcome: {
    margin:'30px',
    fontFamily: "cursive"

  },
  img:{
    
    borderRadius:'20px',
    maxWidth:'100%'
  },
  [theme.breakpoints.down('xs')]:{
    img:{
      borderRadius:'0px',

    }
  },

  typo:{
    fontStyle:'italic'
  },
  intro:{
    margin:'30px 40px'
  }
}));

export default myStyles;
